import Style from "ol/style/Style.js";
import CircleStyle from "ol/style/Circle.js";
import Fill from "ol/style/Fill.js";
import Stroke from "ol/style/Stroke.js";

export const styleFunction = (feature) => {
  const geometryType = feature.getGeometry().getType();

  switch (geometryType) {
    case "Point":
      return new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({ color: "rgba(0, 153, 255)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
      });

    case "MultiPolygon":
      return new Style({
        fill: new Fill({
          color: "rgba(1, 153, 255, 0.1)",
        }),
        stroke: new Stroke({
          color: "rgba(0, 153, 255)",
          width: 2,
        }),
      });

    case "MultiLineString":
      return new Style({
        stroke: new Stroke({
          color: "rgba(0, 153, 255)",
          width: 3,
        }),
      });

    case "MultiPoint":
      return new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({ color: "rgba(0, 153, 255)" }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
      });

    default:
      return new Style({
        stroke: new Stroke({
          color: "rgba(0, 153, 255)",
          width: 2,
        }),
        fill: new Fill({
          color: "rgba(0, 153, 255, 0.1)",
        }),
      });
  }
}